import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { UrlService } from '../../../../environments/urlService';
import { Fund, FundBasicInfo } from '../../fund-performance/dto/Fund';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { Observable } from 'rxjs';
import { FundOrderDTO } from '../dto/FundOrderDTO';

@Injectable({
  providedIn: 'root',
})
export class FundService {
  private readonly url: string;

  constructor(private http: HttpClient, private urlService: UrlService) {
    this.url = this.urlService.getFmsUrl() + 'fund';
  }

  update(fund: Fund, managementCompanyUUID = null, prevEntityUUID = null): Promise<void> {
    let parameters = new HttpParams();
    if (managementCompanyUUID) {
      parameters = parameters.set('managementCompanyUUID', managementCompanyUUID);
    }
    if (prevEntityUUID) {
      parameters = parameters.set('prevEntityUUID', prevEntityUUID);
    }
    return this.http.put<void>(this.url, fund,
      {
        params: parameters
        , withCredentials: true, context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        responseType: 'json',
      },
    ).toPromise();
  }

  create(fund: Fund, orgUUID: string, managementCompanyUUID = null): Promise<Fund> {
    const parameters = managementCompanyUUID ?
      new HttpParams().set('orgUUID', orgUUID).set('managementCompanyUUID', managementCompanyUUID) :
      new HttpParams().set('orgUUID', orgUUID);
    return this.http.post<Fund>(this.url, fund,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        params: parameters,
        withCredentials: true,
        responseType: 'json',
      },
    ).toPromise();
  }

  delete(fundUUID: string): Promise<void> {
    return this.http.delete<void>(this.url + '/' + fundUUID,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        responseType: 'json',
      },
    ).toPromise();
  }

  copyFund(fund: Fund): Promise<void> {
    return this.http.post<void>(this.url + '/copy', fund,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        responseType: 'json',
      },
    ).toPromise();
  }

  updateFundOrders(fundOrderDTOs: FundOrderDTO[], orgUuid: string): Observable<void> {
    return this.http.put<void>(this.url + '/order', fundOrderDTOs, {
      params: { orgUuid },
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
    });
  }

  getRelatedToSelectedCompanyFunds(companyUUID: string, date: Date): Observable<FundBasicInfo[]> {
    const period = date.toString();
    return this.http.get<FundBasicInfo[]>(this.url + '/related-funds', {
      params: { companyUUID, period },
      withCredentials: true,
    });
  }
}
